import AuthLayout from "~/components/layouts/AuthLayout.vue";
import DefaultLayout from "~/components/layouts/DefaultLayout.vue";
export const cabinetRoutes: any[] = [
  {
    path: "/cabinet",
    children: [
      {
        path: "profile",
        children: [
          {
            path: "",
            name: "/cabinet/profile/",
            component : () => import("~/pages/cabinet/profile/index.vue"),
            meta: {
              subject: "Auth",
              action: "read",
              layout : DefaultLayout
            },
            alias: [],
          },
          {
            path: "edit",
            name: "/cabinet/profile/edit",
            component : () => import("~/pages/cabinet/profile/edit.vue"),
            meta: {
              subject: "Auth",
              action: "read",
              layout : DefaultLayout
            },
            alias: [],
          },
        ],
      },
    ],
  },
  {
    path: "/compare",
    children: [
      {
        path: "",
        name: "/compare/",
        component : () => import("~/pages/compare/index.vue"),
        meta: {
          subject: "viewComparison",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/dashboard",
    name: "/dashboard",
    component: () => import("~/pages/dashboard.vue"),
    meta: {
      subject: "Auth",  
      action: "read",
      layout : DefaultLayout
    },
    alias: [] as any,
  },
  {
    path: "/departments",
    children: [
      {
        path: "",
        name: "/departments/",
        component : () => import("~/pages/departments/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Bo'limlar",
              link: null,
            },
          ],
          subject: "viewDepartment",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/diary",
    children: [
      {
        path: "",
        name: "/diary/",
        component : () => import("~/pages/diary/index.vue"),
        meta: {
          subject: "viewDiary",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/functional-tasks",
    children: [
      {
        path: "",
        name: "/functional-tasks/",
        component : () => import("~/pages/functional-tasks/index.vue"),
        meta: {
          subject: "viewFunctionalTask",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id",
        name: "/functional-tasks/[id]",
        component : () => import("~/pages/functional-tasks/[id].vue"),
        meta: {
          subject: "viewFunctionalTask",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/kanban",
    children: [
      {
        path: "",
        name: "/kanban/",
        component : () => import("~/pages/kanban/index.vue"),
        meta: {
          layout : DefaultLayout,
          breadcrumbs: [
            {
              title: "Kanban doska",
              link: null as any,
            },
          ],
        },
        alias: [] as any,
      },
    ],
  },
  {
    path: "/monthly-plan",
    children: [
      {
        path: "",
        name: "/monthly-plan/",
        component : () => import("~/pages/monthly-plan/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Oylik ish reja",
              link: null,
            },
          ],
          subject: "viewMonthlyWorkPlan",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id",
        name: "/monthlyPlanDepartments",
        component : () => import("~/pages/monthly-plan/[departmentId]/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Oylik ish reja",
              link: "/monthly-plan",
            },
            {
              title: "Ish rejasini yaratish",
              link: null,
            },
          ],
          action: "read",
          subject: "viewMonthlyWorkPlan",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id/:userId/create",
        name: "monthlyPlanMainTaskCreate",
        component : () => import("~/pages/monthly-plan/[departmentId]/[userId]/create.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Oylik ish reja",
              link: "/monthly-plan",
            },
            {
              title: "Ish rejasini yaratish",
              link: null,
            },
            {
              title: "Vazifa yaratish",
              link: null,
            },
          ],
          action: "read",
          subject: "viewMonthlyWorkPlan",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: "create",
        name: "/monthly-plan/create",
        component : () => import("~/pages/monthly-plan/create.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Oylik ish reja",
              link: "/monthly-plan",
            },
            {
              title: "Ish rejasini yaratish",
              link: null,
            },
          ],
          action: "create",
          subject: "createMonthlyWorkPlan",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/not-authorized",
    name: "/not-authorized",
    component : () => import("~/pages/not-authorized.vue"),
    meta: {
      subject: "Auth",
      action: "read",
      layout : DefaultLayout
    },
    alias: [],
  },
  {
    path: "/positions",
    children: [
      {
        path: "",
        name: "/positions/",
        component : () => import("~/pages/positions/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Lavozimlar",
              link: null,
            },
          ],
          action: "read",
          subject: "viewPosition",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },

  {
    path: "/project-categories",
    children: [
      {
        path: "",
        name: "/project-categories/",
        component : () => import("~/pages/project-categories/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Loyiha turlari",
              link: null,
            },
          ],
          action: "read",
          subject: "viewProject",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/projects",
    children: [
      {
        path: "",
        name: "/projects/",
        component : () => import("~/pages/projects/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Ish jarayoni",
              link: null as any,
            },
            {
              title: "Loyihalar",
              link: null,
            },
          ],
          action: "read",
          subject: "viewProject",
          layout : DefaultLayout
        },
        alias: [] as any,
      },
      {
        path: ":id",
        children: [
          {
            path: "",
            name: "/projects/[id]/",
            component : () => import("~/pages/projects/[id]/index.vue"),
            meta: {
              breadcrumbs: [
                {
                  title: "Ish jarayoni",
                  link: null as any,
                },
                {
                  title: "Vazifalar",
                  link: null,
                },
              ],
              action: "read",
              subject: "viewProject",
              layout : DefaultLayout
            },
            alias: [] as any,
          },
          {
            path: "edit",
            name: "/projects/[id]/edit",
            component : () => import("~/pages/projects/[id]/edit.vue"),
            meta: {
              action: "update",
              subject: "editProject",
              layout : DefaultLayout
            },
            alias: [] as any,
          },
        ],
      },
      {
        path: "create",
        name: "/projects/create",
        component : () => import("~/pages/projects/create.vue"),
        meta: {
          action: "create",
          subject: "createProject",
          layout : DefaultLayout
        },
        alias: [] as any,
      },
    ],
  },
  {
    path: "/results",
    children: [
      {
        path: "",
        name: "/results/",
        component : () => import("~/pages/results/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Samaradorlik",
              link: "/results",
            },
          ],
          subject: "viewEfficiency",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id",
        name: "/results/[id]",
        component : () => import("~/pages/results/[id].vue"),
        meta: {
          subject: "viewEfficiency",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/role-management",
    children: [
      {
        path: "",
        name: "/role-management/",
        component : () => import("~/pages/role-management/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Rollarni boshqarish",
              link: "role-management",
            },
          ],
          subject: "viewRole",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: "create",
        name: "/role-management/create",
        component : () => import("~/pages/role-management/create.vue"),
        meta: {
          subject: "createRole",
          action: "create",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: "update",
        children: [
          {
            path: ":id",
            name: "/role-management/update/[id]",
            component : () => import("~/pages/role-management/update/[id].vue"),
            meta: {
              subject: "editRole",
              action: "update",
              layout : DefaultLayout
            },
            alias: [],
          },
        ],
      },
    ],
  },

  // video guide
  {
    path: "/video-guide",
    children: [
      {
        path: "",
        name: "/video-guide/",
        component : () => import("~/pages/video-guide/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Video qo'llanmalar",
              link: "video-guide",
            },
          ],
          subject: "Auth",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id",
        name: "/video-guide-inner",
        component : () => import("~/pages/video-guide/[id].vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Video qo'llanmalar",
              link: "video-guide",
            },
          ],
          subject: "Auth",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      // {
      //   path: "create",
      //   name: "/role-management/create",
      //   component : () => import("~/pages/role-management/create.vue"),
      //   meta: {
      //     subject: "createRole",
      //     action: "create",
      //     layout : DefaultLayout
      //   },
      //   alias: [],
      // },
      // {
      //   path: "update",
      //   children: [
      //     {
      //       path: ":id",
      //       name: "/role-management/update/[id]",
      //       component : () => import("~/pages/role-management/update/[id].vue"),
      //       meta: {
      //         subject: "editRole",
      //         action: "update",
      //         layout : DefaultLayout
      //       },
      //       alias: [],
      //     },
      //   ],
      // },
    ],
  },

  {
    path: "/staff",
    children: [
      {
        path: "",
        name: "/staff/",
        component : () => import("~/pages/staff/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Xodimlar",
              link: null as any,
            },
          ],
          action: "read",
          subject: "viewEmployee",
          layout : DefaultLayout
        },
        alias: [] as any,
      },
      {
        path: ":id",
        children: [
          {
            path: "",
            name: "/staff/[id]/",
            component : () => import("~/pages/staff/[id]/index.vue"),
            meta: {
              action: "read",
              subject: "viewEmployee",
              layout : DefaultLayout
            },
            alias: [] as any,
          },
          {
            path: "dashboard",
            children: [
              {
                path: "",
                name: "/staff/[id]/dashboard/",
                component : () => import("~/pages/staff/[id]/dashboard/index.vue"),
                meta: {
                  action: "read",
                  subject: "viewEmployee",
                  layout : DefaultLayout
                },
                alias: [] as any,
              },
            ],
          },
          {
            path: "edit",
            name: "/staff/[id]/edit",
            component : () => import("~/pages/staff/[id]/edit.vue"),
            meta: {
              action: "update",
              subject: "editEmployee",
              layout : DefaultLayout
            },
            alias: [],
          },
        ],
      },
      {
        path: "create",
        name: "/staff/create",
        component : () => import("~/pages/staff/create.vue"),
        meta: {
          action: "create",
          subject: "createEmployee",
          layout : DefaultLayout
        },
        alias: [] as any,
      },
    ],
  },

  {
    path: "/percentage-indicators",
    children: [
      {
        path: "",
        name: "PercentageIndicators",
        component : () => import("~/pages/percentage-indicators/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Foiz ko'rsatkichlar",
              link: null as any,
            },
          ],
          action: "read",
          subject: "viewEmployee",
          layout : DefaultLayout
        },
        alias: [] as any,
      },
    ],
  },

  {
    path: "/staffs-dashboard",
    name: "/staffs-dashboard",
    component : () => import("~/pages/staffs-dashboard.vue"),
    meta: {
      layout : DefaultLayout
    }
  },
  {
    path: "/structure",
    children: [
      {
        path: "",
        name: "/structure/",
        component : () => import("~/pages/structure/index.vue"),
        meta: {
          subject: "Auth",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/tags",
    children: [
      {
        path: "",
        name: "/tags/",
        component : () => import("~/pages/tags/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Teglar",
              link: null,
            },
          ],
          action: "read",
          subject: "viewTag",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/tasks",
    children: [
      {
        path: "",
        name: "/tasks/",
        component : () => import("~/pages/tasks/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Ish jarayoni",
              link: null,
            },
            {
              title: "Vazifalar",
              link: null,
            },
          ],
          subject: "viewTask",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id",
        name: "/tasks/[id]",
        component : () => import("~/pages/tasks/[id].vue"),
        meta: {
          subject: "viewTask",
          action: "read",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: "create",
        name: "/tasks/create",
        component : () => import("~/pages/tasks/create.vue"),
        meta: {
          subject: "createTask",
          action: "create",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: "update",
        children: [
          {
            path: ":id",
            name: "/tasks/update/[id]",
            component : () => import("~/pages/tasks/update/[id].vue"),
            meta: {
              subject: "editTask",
              action: "update",
              layout : DefaultLayout
            },
            alias: [],
          },
        ],
      },
    ],
  },
  {
    path: "/tasks-distribution",
    children: [
      {
        path: "",
        name: "/tasks-distribution/",
        component : () => import("~/pages/tasks-distribution/index.vue"),
        meta: {
          breadcrumbs: [
            {
              title: "Vazifalar taqsimoti",
              link: null,
            },
          ],
          action: "read",
          subject: "Auth",
          layout : DefaultLayout
        },
        alias: [],
      },
      {
        path: ":id",
        name: "/tasks-distribution/[id]",
        component : () => import("~/pages/tasks-distribution/[id].vue"),
        meta: {
          action: "read",
          subject: "Auth",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/workspace",
    children: [
      {
        path: "",
        name: "/workspace/",
        component : () => import("~/pages/workspace/index.vue"),
        meta: {
          action: "read",
          subject: "viewWorkstationOnMenu",
          layout : DefaultLayout
        },
        alias: [],
      },
    ],
  },
  {
    path: "/auth/login",
    name: "Login",
    component: () => import("~/pages/auth/login/index.vue"),
    meta: { layout: AuthLayout, subject: "Auth", action: "read" },
  },
  {
    path: "/auth/login/forget-password",
    name: "ForgetPassword",
    component: () => import("~/pages/auth/login/forget-password.vue"),
    meta: { layout: AuthLayout, subject: "Auth", action: "read" },
  },
];
